var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.39a1.67 1.67 0 1 0 3.33 0 1.67 1.67 0 0 0-3.33 0Zm3.33 0h6.04-6.04Zm-5.2 0h1.87-1.88Zm6.04 5a1.67 1.67 0 1 0 3.33 0 1.67 1.67 0 0 0-3.33 0Zm0 0H4.38m11.25 0h-1.88m-2.5 5c.07 1.34.5 2.64 1.25 3.75h-5a7.44 7.44 0 0 0 1.25-3.75m-3.12 3.75h8.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88 1.39h16.25s1.25 0 1.25 1.25v12.5s0 1.25-1.25 1.25H1.88s-1.25 0-1.25-1.25V2.64s0-1.25 1.25-1.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .76)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorConfig);
export default __webpack_public_path__ + "static/media/monitor-config.067caa1416f2324372b2a1c322420c16.svg";
export { ForwardRef as ReactComponent };